// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2S9Xu","label":"LabeledBox_label__3mXwT"};